module.exports = __webpack_public_path__ + "static/media/verificaçãoCNHError.0cc8ca53.jpg";